import type { ReactNode } from "react";
import { Heading } from "../atoms/Heading";
import { Text } from "../atoms/Text";
import { cn } from "../lib/cn";

export interface EmptyStateProps {
	title: string;
	description?: string;
	icon?: ReactNode;
	action?: ReactNode;
	className?: string;
}

function EmptyState({
	title,
	description,
	icon,
	action,
	className,
}: EmptyStateProps): ReactNode {
	return (
		<div
			className={cn(
				"flex flex-col items-center justify-center gap-4 py-16 text-center",
				className,
			)}
		>
			{icon && (
				<div className="text-mutedForeground" aria-hidden="true">
					{icon}
				</div>
			)}
			<Heading size="lg">{title}</Heading>
			{description && (
				<Text textColor="mutedForeground" className="max-w-sm">
					{description}
				</Text>
			)}
			{action && <div className="mt-2">{action}</div>}
		</div>
	);
}
EmptyState.displayName = "EmptyState";

export default EmptyState;
export { EmptyState };
